import { NgModule, Optional, SkipSelf, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// App Modules
import { CoreModule } from '@app/core/core.module';
import { ErrorsModule } from '@app/errors/errors.module';
import { environment } from '@app/config/environment';
import { AppRoutingModule } from "@app/app-routing.module";

import { AppComponent } from "@app/app.component";

// Import Shell Components
import {
    AppShellComponent,
    AppHeaderComponent,
    AppFooterComponent,
    BuilderShellComponent,
    BuilderHeaderComponent,
    BuilderFooterComponent
} from '@app/base/shells';

// Import Alert Component
import { AlertComponent } from '@app/base/alerts/alert.component';

// Import App Services
import {
    AccountService,
    LimitlessUiService,
    LoggerService,
    EnvironmentService,
    ConstantsService,
    SessionService,
    LookupsService
} from '@app/core/services';

// Import Alert Service
import { AlertService } from '@app/base/alerts/alert.service';

// Import SoCo Services
import {
    SocoConfigurationService,
    SocoHttpService,
    SocoAlertService,
    SocoModalService
} from '@app/base/soco';


@NgModule({
    imports: [
        // Angular Modules
        BrowserModule,
        BrowserAnimationsModule,
        // TODO: DSS: ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),

        //App Modules
        CoreModule.forRoot(),
        AppRoutingModule,
        ErrorsModule
    ],
    declarations: [
        AppComponent,
        AppShellComponent,
        AppHeaderComponent,
        AppFooterComponent,
        BuilderShellComponent,
        BuilderHeaderComponent,
        BuilderFooterComponent,
        AlertComponent
    ],
    providers: [ // TODO: Should not provide services again, do more reseach!!
        AccountService,
        LimitlessUiService,
        LoggerService,
        ConstantsService,
        EnvironmentService,
        SessionService,
        LookupsService,
        SocoConfigurationService,
        SocoHttpService,
        SocoAlertService,
        SocoModalService,
        AlertService
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(
        @Optional() @SkipSelf() parentModule: AppModule,
        private logger: LoggerService,
        private env: EnvironmentService) {

        // Check if Root Shell Module already loaded.
        if (parentModule) { throw new Error('RootShellModule is already loaded.'); }

        // Enable consol logs if not SoCo\Production environment, but in browser console, set ConsolLog = true to see logs.
        (<any>window).ConsolLog = !(this.env.isSoCoEnv || this.env.isProduction);

        // Add app identity to console.
        this.logger.log(`%c   © ${(new Date()).getFullYear()} Southern Company Gas.              `,
            'background: #eb1c24; color: white; font-size: 15px;,');
        this.logger.log(`%c   Onboarding | External -> ${this.env.appVersion}   `, 'background: #00bef6; color: black; font-size: 15px;');
        this.logger.log(`%c » Root Shell Bootstrapped             `, 'background: #3c3c3c; color: white; font-size: 13px;');
    }
}
